import { Color } from '@kite-js/theme-types';

const blue: Color = {
    50: '#F0F4F8',
    100: '#ABADD3',
    200: '#6D6FB3',
    300: '#255F82',
    400: '#002D72',
    500: '#002072',
};

export default blue;
